import React from "react";
import { Layout } from "antd";

// import "../css/MenuCompleto.css";
import { HeaderAspirante } from "./HeaderAspirante";

const { Content } = Layout;

const MenuAspirante = ({ componente, btnCerrarSesion }) => {
    return (
        <>
            <div style={{ height: '100vh' }}>
                <HeaderAspirante btnCerrarSesion = { btnCerrarSesion } />

                <Layout>
                    <Layout style={{ padding: "0 24px 24px" }}>
                        <Content
                            className="site-layout-background2"
                            style={{
                                padding: 24,
                                marginTop: 16,
                                minHeight: 280,
                                background: '#fff',
                            }}
                        >
                            { componente }
                        </Content>
                    </Layout>
                </Layout>
            </div>
        </>
    );
};

export default MenuAspirante;
